module.exports = __webpack_public_path__ + "img/pump-true.6802d044.png";